// AdminPanel.tsx — container for the site-admin "Admin" tab. Holds a lightweight
// sub-navigation so related admin config lives in one place instead of cluttering
// the top nav (e.g. Games, Consumable heat config).

import React, { useState } from "react";
import AdminGamesPanel from "./AdminGamesPanel";
import AdminConsumablesPanel from "./AdminConsumablesPanel";
import AdminSheetTemplatesPanel from "./AdminSheetTemplatesPanel";

type SubTab = "games" | "consumables" | "sheets";

const SUB_TABS: { id: SubTab; label: string }[] = [
  { id: "games", label: "Games" },
  { id: "consumables", label: "Consumables" },
  { id: "sheets", label: "Raid sheets" },
];

export default function AdminPanel() {
  const [sub, setSub] = useState<SubTab>("games");

  return (
    <div className="space-y-5">
      <nav className="flex items-center gap-1 p-1 rounded-full border border-[var(--c-line)] bg-[var(--c-surface)] w-fit">
        {SUB_TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setSub(t.id)}
            className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors ${
              sub === t.id ? "bg-[var(--c-sunken-2)] text-[var(--c-ink)]" : "text-[var(--c-ink-3)] hover:text-[var(--c-ink)]"
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {sub === "games" && <AdminGamesPanel />}
      {sub === "consumables" && <AdminConsumablesPanel />}
      {sub === "sheets" && <AdminSheetTemplatesPanel />}
    </div>
  );
}
